import { PluginListenerHandle, registerPlugin } from '@capacitor/core';
import { TScanModes } from '../../input-app/rfid-tag-reader.service';

export type TNFCConnectionState = {
  connectionState: 'CONNECTED' | 'DISCONNECTED';
};

export interface NFCReaderPlugin {

  /**
   * @description starts the process to connect nfc reader natively
   */
  connectNFC(options: {scanMode: TScanModes}): Promise<{ status: boolean }>;

  /**
   * @description disconnects NFC
   */
  disconnectNFC(): Promise<void>;

  /**
   * @description helps to start the tag read for NFC.
   * @returns status => true / false
   */
  startNFCRead(): Promise<{ status: boolean }>;

  /**
   * @description helps to stop the tag read for NFC.
   * @returns status => true or false
   */
  stopNFCRead(): Promise<{ status: boolean }>;

  /**
   * @description helps to update the NFC scan mode. By Default single scan mode
   * @param scanMode - single_tag or multi_tag.
   * @returns status => status or error, based on Mode toggle sucess of failure (status would be true always since we are only updating a variable on the plugin)
   */
  updateScanMode(options: { scanMode: string }): Promise<{ status: boolean }>;

  /**
   * @description subscribes to connection state update
   */
  addListener(
    eventName: 'connectionUpdateListener',
    listenerFunc: (info: TNFCConnectionState) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;

  /**
   * @description subscribes to scanned nfc data
   */
  addListener(
    eventName: 'onNFCScanned',
    listenerFunc: (info: { tagList: string[] }) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;
}

const NFCReaderPlugin = registerPlugin<NFCReaderPlugin>('NFCReaderPlugin');

export default NFCReaderPlugin;
